import { makeAutoObservable } from "mobx";
import { IDropOffSettings, ShippingInstructionsChangeTrigger } from "../return-method-types";
import { IChangeable } from "../../../stores/types";
import { IShippingConnection } from "../../../models/IntegrationsTypes";

interface IDropOffSettingsChanges extends Partial<IDropOffSettings>{};

class DropOffSettingsStore implements IChangeable<IDropOffSettingsChanges> {
    private _changes: IDropOffSettingsChanges = {};
    private _model?: IDropOffSettings|null;
    private _onTriggerInstructionsChange: (trigger: ShippingInstructionsChangeTrigger) => void;


    constructor(
        private _getShippingIntegrations: () => IShippingConnection[],
        onTriggerInstructionsChange: (trigger: ShippingInstructionsChangeTrigger) => void,
    ) {
        this._onTriggerInstructionsChange = onTriggerInstructionsChange;
        makeAutoObservable(this);
	}

    public get deleted() { return this._changes._deleted ?? false };
    public get returnMethodId() { return this._changes.return_method_id ?? this._model?.return_method_id };
    public get shippingConnectionId() { return this._changes.shipping_connection_id ?? this._model?.shipping_connection_id };
    public get aggregatorCode() {
        return this._getShippingIntegrations()?.find(aggregator => 
            aggregator.id === this.shippingConnectionId)?.aggregator_code;
    }


    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IDropOffSettingsChanges;
    }

    public setModel(model: IDropOffSettings|undefined|null): void {
        this._model = model;
        this._changes = {} as IDropOffSettingsChanges;
    }

    public setDeleted(v: boolean) {
        this._changes._deleted = v;
    }

    public getUpdatedModel(): IDropOffSettings|undefined {
        const updatedModel = { ...this._model, ...this._changes, _has_changes: this.hasChanges() } as IDropOffSettings;
        const isNewAndDeleted = !(this._model ?? {}).id && this.deleted;
        if (isNewAndDeleted) {
            return undefined;
        }

        return updatedModel;
    }

    public setShippingConnectionId(v: number): void { 
        this._changes.shipping_connection_id = v;
        this._onTriggerInstructionsChange(ShippingInstructionsChangeTrigger.DROP_OFF_CONNECTION);
    }
}

export default DropOffSettingsStore;